/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgSmartphone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={48}
    height={48}
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.1201 7.99988C13.1201 7.51387 13.5141 7.11988 14.0001 7.11988H34.0001C34.4861 7.11988 34.8801 7.51387 34.8801 7.99988V39.9999C34.8801 40.4859 34.4861 40.8799 34.0001 40.8799H14.0001C13.5141 40.8799 13.1201 40.4859 13.1201 39.9999V7.99988ZM14.0001 0.879883C10.0678 0.879883 6.88007 4.06762 6.88007 7.99988V39.9999C6.88007 43.9321 10.0678 47.1199 14.0001 47.1199H34.0001C37.9323 47.1199 41.1201 43.9321 41.1201 39.9999V7.99988C41.1201 4.06762 37.9323 0.879883 34.0001 0.879883H14.0001ZM24 30.4798C22.2769 30.4798 20.88 31.8767 20.88 33.5998C20.88 35.323 22.2769 36.7198 24 36.7198H24.02C25.7431 36.7198 27.14 35.323 27.14 33.5998C27.14 31.8767 25.7431 30.4798 24.02 30.4798H24Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgSmartphone
